import { APIProvider } from '@vis.gl/react-google-maps';
import App from 'antd/lib/app';
import { useContext, useEffect } from 'react';
import { AbilityContext } from 'src/components/ability/can';
import config from 'src/config';
import { useCarbonIntensityListQuery } from 'src/domain/carbon-intensity/queries';
import { useSiteMapStore } from './useSiteMapStore';

const GOOGLE_MAPS_LIBRARIES: string[] = ['marker'];

export const SitesMapProvider = ({ children }: { children: React.ReactNode }) => {
    const { notification } = App.useApp();
    const ability = useContext(AbilityContext);
    const setCarbonIntensity = useSiteMapStore(state => state.setCarbonIntensity);

    const {
        data: carbonIntensity = [],
        isError,
        error,
    } = useCarbonIntensityListQuery({
        enabled: ability.can('read', 'carbon-intensity'),
    });

    useEffect(() => {
        setCarbonIntensity(carbonIntensity);
    }, [carbonIntensity]);

    if (isError) {
        notification.error({
            key: 'carbon-intensity-fetch-error',
            message: error?.message || 'Cannot fetch Carbon Intensity!',
        });
    }

    return (
        <APIProvider apiKey={config.GOOGLE_API_KEY} libraries={GOOGLE_MAPS_LIBRARIES}>
            {children}
        </APIProvider>
    );
};
